<template>
  <div class="calculator-container">
    <div class="enterprise-container"><el-empty description="暂无数据"></el-empty></div>
  </div>
</template>

<script>
export default {
  name: 'Calculator',
  data() {
    return {
      queryForm: {
        startNode: '',
        relationType: 'equity',
        depth: 2,
        endNode: ''
      },
      pathList: []
    }
  },
  methods: {
    handleQuery() {
      // 模拟查询结果
      if (this.queryForm.startNode) {
        this.pathList = [
          { path: this.queryForm.startNode + ' → 中间企业A → 目标企业', distance: 2, strength: 85 },
          { path: this.queryForm.startNode + ' → 中间企业B → 中间企业C → 目标企业', distance: 3, strength: 65 }
        ]
        this.$message.success('查询完成')
      } else {
        this.$message.warning('请输入起始节点')
      }
    }
  }
}
</script>

<style scoped>
.calculator-container {
  padding: 0;
}

.graph-container {
  height: 400px;
  background-color: #f5f7fa;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.graph-placeholder {
  text-align: center;
  color: #909399;
}

.graph-placeholder i {
  font-size: 64px;
  margin-bottom: 20px;
}

.graph-placeholder p {
  font-size: 14px;
}
</style>
